import React, { useState } from "react";
import Visitor from "./Visitor";
import Vitrin from "./Vitrin";
import "./css/UserRole.css";
import UserStatus from "../context/UserStatus";
import { ShowTypeProvider } from "../context/ShowTypeContext";
import { LoginProvider } from "../context/LoginContext";
import { ThemeProvider } from "../context/ThemeContext";
import Kala from "./Kala";
import { ProductProvider } from "../context/ProductContext";

const getUrlParam = () => {
  var vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
};

const UserRole = () => {
  const [userStatus, setUserStatus] = useState(false);

  const [kala, setKala] = useState(getUrlParam().kala);

  const login = () => {
    setUserStatus(true);
  };

  const visitor = getUrlParam().k;
  const vitrin = getUrlParam().v;

  const roleObj = {
    visitorId: visitor === undefined ? 0 : parseInt(visitor),
    vitrinId: vitrin === undefined ? 0 : parseInt(vitrin),
  };

  if (roleObj.vitrinId !== 0) {
    return (
      <ShowTypeProvider>
        <LoginProvider id={roleObj.vitrinId}>
          <UserStatus.Provider value={{ status: userStatus, login: login }}>
            <ThemeProvider>
              <ProductProvider>
                <Vitrin
                  id={roleObj.vitrinId}
                  kala={kala}
                  isReturn={getUrlParam().p}
                />
              </ProductProvider>
            </ThemeProvider>
          </UserStatus.Provider>
        </LoginProvider>
      </ShowTypeProvider>
    );
  } else if (roleObj.visitorId !== 0) {
    return (
      <ShowTypeProvider>
        <Visitor id={roleObj.visitorId} />
      </ShowTypeProvider>
    );
  } else {
    return <div>user not found</div>;
  }
};

export default UserRole;
